module.exports = __webpack_public_path__ + "static/media/mennojongerius.bd0b1ef7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/mennojongerius.webp
// module id = 799
// module chunks = 0